const ORDINALS = ['th', 'st', 'nd', 'rd']
const SIZES = ['B', 'KB', 'MB', 'GB', 'TB']

const escapeSpecialChars = (string: string) =>
	string.replace(/[+\-&|!(){}[\]^"~*?:\\]/gm, char => `\\${char}`)

/*
* Use intl if you will need to support other locales
const ordinal = new Intl.PluralRules('en-US', { type: 'ordinal' })

const suff: Partial<Record<Intl.LDMLPluralRule, string>> = {
	few: 'rd',
	one: 'st',
	two: 'nd'
}
	const key = ordinal.select(asNumber)
	return `${asNumber}${suff[key] ?? 'th'}`
*/

function ordinalNumber(numberLike: unknown) {
	const asNumber = Number(numberLike)

	if (Number.isNaN(asNumber)) {
		return numberLike
	}

	const v = asNumber % 100

	return asNumber + (ORDINALS[(v - 20) % 10] || ORDINALS[v] || ORDINALS[0])
}

const formatFileSize = (bytes: number) => {
	let size = bytes

	let index = 0
	for (; size >= 1024 && index < SIZES.length - 1; index++) {
		size /= 1024
	}

	size = Math.round(size)
	return `${size} ${SIZES[index]}`
}

export { escapeSpecialChars, formatFileSize, ordinalNumber }
